<template>
<div>
  <el-button style="width:100%;" type="primary" size="small" @click="open">사용자정의 자원</el-button>
  <w-sliding-popup ref="slidingPopup" :title="title" top="50px" width="700px" :default-content="false" @close="onClose">
    <div slot="content" class="body-content-no-scroll" style="height:100%;">
      <el-row class="title-bar" type="flex" justify="end">
        <w-header-search-button @click="showSearchTool = !showSearchTool" />
      </el-row>
      <el-table-wrapper style="height: calc(100% - 41px);" :fit-height="true" ref="table" :data="tableData" :columns="columns" :show-custom-header="true" :show-search-tool="showSearchTool" :pagination="true" :column-default="columnDefault">
        <template slot-scope="scope" slot="rsc-value-slot">
          <span v-if="scope.row.rscUnit === '%'">
            <el-row type="flex" v-if="!isNil(scope.row.rscValue) && isNumber(scope.row.rscValue) && convertToNumber(scope.row.rscValue) >= 0">
              <el-col :span="20">
                <el-progress :text-inside="true" :stroke-width="14" :percentage="convertToNumber(scope.row.rscValue)" :color="scope.row.eventlevelColorBg" />
              </el-col>
              <el-col :span="4">
                <i v-if="scope.row.eventlevelId !== null && scope.row.eventlevelId !== undefined" class="fa fa-exclamation-triangle" :style="`color:${scope.row.eventlevelColorBg}`"/>
              </el-col>
            </el-row>
            <span v-else>{{ getValueAfterCheckEmpty(scope.row.rscValue) }}</span>
          </span>
          <span v-else>
            {{ convertValuByUnit(scope.row) }}
          </span>
        </template>
      </el-table-wrapper>
    </div>
  </w-sliding-popup>
</div>
</template>

<script>
import isNil from 'lodash/isNil';
import { columnDefault } from '@/constants/table';
import msgUtil from '@/utils/message';
import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';
import { convertValuByUnit, isNumber } from '@/utils/number';
import netdeviceInfoAPi from '@/api/performance/netdevice/netdevice-info';
import WRscPerfEventProgressBar from '@/components/progressbar/RscPerfEventProgressBar';

export default {
  name: 'WNetdeviceUserDefineOidRscPopupButton',
  componentns: {
    WRscPerfEventProgressBar,
  },
  props: {
    /**
     * 장비 정보
     * @type {Object}
     */
    objInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      columnDefault,
      loading: false,
      showSearchTool: false,
      tableData: [],
      columns: [
        {
          prop: 'rscId',
          label: '자원 아이디',
          searchable: true,
        },
        {
          prop: 'rscName',
          label: '자원명',
          searchable: true,
        },
        {
          prop: 'rscValue',
          label: '값',
          scopedSlot: 'rsc-value-slot',
        },
      ],
    };
  },
  computed: {
    objId() {
      return isNil(this.objInfo) && isNil(this.objInfo.obj) ? null : this.objInfo.obj.objId;
    },
    title() {
      const title = '사용자정의 자원';
      return isNil(this.objInfo) ? title : `[${this.objInfo.label}] ${title}`;
    },
  },
  methods: {
    isNil,
    isNumber,
    getValueAfterCheckEmpty,
    /**
     * 팝업을 연다.
     * @author Ju
     * @return {[type]} [description]
     */
    open() {
      this.loadData();
      this.$refs.slidingPopup.open();
    },
    /**
     * 사용자 정의 자원 정보를 로드한다.
     * @author Ju
     * @return {[type]} [description]
     */
    loadData() {
      this.loading = true;
      netdeviceInfoAPi
        .getUserDefineOidRscCurrentValues(this.objId)
        .then((response) => {
          if (response.data.success) {
            this.tableData = response.data.data;
          } else {
            this.failToLoad();
          }
        })
        .catch(() => {
          this.failToLoad();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * 데이터 로드 실패 처리
     * @author Ju
     * @return {[type]} [description]
     */
    failToLoad() {
      this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '사용자정의 자원', false));
    },
    /**
     * 자원 값을 단위에 맞게 변환하여 반환한다.
     * @author Ju
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    convertValuByUnit(data) {
      if (isNil(data.rscValue)) {
        return EMPTY_TEXT;
      } else if (isNumber(data.rscValue) && !isNil(data.rscUnit) && data.rscUnit !== '') {
        return convertValuByUnit(data.rscValue, data.rscUnit);
      }
      return data.rscValue;
    },
    /**
     * 숫자 값으로 변환하여 반환한다.
     * @author Ju
     * @param  {[type]} value [description]
     * @return {[type]}       [description]
     */
    convertToNumber(value) {
      return Number(value);
    },
    /**
     * 팝업 close 이밴트 핸들러
     * @author Ju
     * @return {[type]} [description]
     */
    onClose() {
      this.tableData = [];
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/performance/node/popup/components/NetdeviceUserDefineOidRscPopupButton.vue